import { EvtHeader } from "components/header";
import React from "react";
import HolidayForm from "../form";

const CreateHoliday = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Holiday" />
      <div className="p-6 max-w-2xl">
        <HolidayForm />
      </div>
    </div>
  );
};

export default CreateHoliday;
